import { format } from 'date-fns';
import { Calendar as CalendarIcon, ChevronDownIcon } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { calendarLocale } from '@/utils/helpers/calendar-locale';

interface DatePickerProps {
  value?: Date | null;
  onChange?: (date?: Date) => void;
  placeholder: string;
  closeOnSelect?: boolean;
  isShowChevron?: boolean;
}

export const DatePicker = ({
  value,
  onChange,
  placeholder,
  closeOnSelect = false,
  isShowChevron = true,
}: DatePickerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (date?: Date) => {
    onChange?.(date);

    if (closeOnSelect) {
      setIsOpen(false);
    }
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger className="px-3" asChild>
        <Button
          type="button"
          data-empty={!value}
          className="w-full justify-between text-left font-normal data-[empty=true]:text-muted-foreground"
        >
          <div className="flex gap-2 items-center">
            <CalendarIcon className="size-5" />
            {value ? (
              format(value, 'dd MMM yyyy', { locale: calendarLocale })
            ) : (
              <span>{placeholder}</span>
            )}
          </div>
          {isShowChevron && <ChevronDownIcon data-icon="inline-end" />}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={value || undefined}
          onSelect={handleSelect}
          defaultMonth={value || undefined}
          locale={calendarLocale}
        />
      </PopoverContent>
    </Popover>
  );
};
